import { useCallback, useState } from "react";
import { debounce } from "Utils";

export const usePagination = (
  fetchDataCallback,
  { containerRef, loadingRowRef }
) => {
  const [currPage, setCurrPage] = useState(0);
  const [prevPage, setPrevPage] = useState(-1);
  const [lastList, setLastList] = useState(false);
  const [paginationLoading, setPaginationLoading] = useState(false);

  const fetchPaginatedData = async (...args) => {
    if (paginationLoading || lastList) return;

    setPaginationLoading(true);
    const response = await fetchDataCallback(...args);

    if (!response.length) {
      setLastList(true);
      setPaginationLoading(false);
      return;
    }
    setPrevPage(currPage);
    setPaginationLoading(false);
  };

  const fetchMoreDataOnScroll = useCallback(
    debounce(() => {
      if (!containerRef.current || !loadingRowRef.current) return;

      const { scrollTop, clientHeight } = containerRef.current;
      const loadingRowOffsetTop = loadingRowRef.current.offsetTop;
      if (
        !paginationLoading &&
        !lastList &&
        scrollTop + clientHeight >= loadingRowOffsetTop - 40
      ) {
        setCurrPage((prev) => prev + 1);
      }
    }, 200),
    [paginationLoading, lastList]
  );

  const goToNextPage = () => {
    setCurrPage((prev) => prev + 1);
  };

  const resetPagination = () => {
    setCurrPage(0);
    setPrevPage(-1);
    setLastList(false);
  };

  return {
    currPage,
    setCurrPage,
    prevPage,
    lastList,
    paginationLoading,
    fetchPaginatedData,
    fetchMoreDataOnScroll,
    goToNextPage,
    resetPagination,
  };
};
